import * as React from "react";
import { SVGProps } from "react";
export const PencilStrokeFillIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M8.25 17.5L11.646 14.083H16.667C17.139 14.083 17.5417 14.2497 17.875 14.583C18.2083 14.9163 18.375 15.3193 18.375 15.792C18.375 16.264 18.2083 16.6667 17.875 17C17.5417 17.3333 17.139 17.5 16.667 17.5H8.25ZM15.312 7.542L11.583 3.812L12.604 2.792C12.9513 2.44466 13.3647 2.271 13.844 2.271C14.3227 2.271 14.7357 2.44466 15.083 2.792L16.333 4.042C16.6663 4.37533 16.833 4.78833 16.833 5.281C16.833 5.77433 16.6663 6.18766 16.333 6.521L15.312 7.542ZM2.5 17.5C2.264 17.5 2.059 17.4133 1.885 17.24C1.71167 17.066 1.625 16.861 1.625 16.625V14.125C1.625 14.0137 1.646 13.906 1.688 13.802C1.72933 13.698 1.79167 13.6043 1.875 13.521L10.354 5.042L14.083 8.771L5.604 17.25C5.52067 17.3333 5.427 17.396 5.323 17.438C5.219 17.4793 5.11133 17.5 5 17.5H2.5Z"
            fill="currentColor"
        />
    </svg>
);
PencilStrokeFillIcon.displayName = "PencilStrokeFillIcon";
